import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import {
	AlertBanner,
	Button,
	Colour,
	ColourStateOutline,
	ColourStateSolid,
	ContentBlock,
	FlexGap,
	GenericLoader,
	StackVertical,
} from '@ukpostbox/frontend-framework';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AuthContext } from 'react-oauth2-code-pkce';
import { useNavigate } from 'react-router';

function OAuthRedirect() {
	const navigate = useNavigate();
	const { logIn, loginInProgress, error, token } = useContext(AuthContext);

	let redirectTimer: any;
	const [tokenAcquired, setTokenAcquired] = useState<boolean>(false);

	const RedirectCountDown = useCallback(() => {
		clearTimeout(redirectTimer);

		redirectTimer = setTimeout(() => {
			setTokenAcquired(true);
		}, 1000);
	}, [token]);

	useEffect(() => {
		if (!loginInProgress && token) {
			RedirectCountDown();
		}
	}, [token, loginInProgress]);

	return (
		<div className='fill-container flex-column flex-gap-md'>
			{!tokenAcquired && <GenericLoader size='4x' />}

			{tokenAcquired && (
				<StackVertical gap={FlexGap.Medium}>
					<AlertBanner
						title='Authorised'
						content={
							localStorage.getItem('lastPath')
								? 'Something went wrong while redirecting you'
								: 'No pre-login path was set'
						}
						icon={faLock}
						colour={Colour.Primary}
						addOn={
							localStorage.getItem('lastPath') ? (
								<Button
									title='Go To Last Path'
									colour={ColourStateSolid.Primary}
									onClick={() => navigate(localStorage.getItem('lastPath') as string)}
								/>
							) : (
								<Button
									title='Go Home'
									colour={ColourStateSolid.Primary}
									onClick={() => navigate('/')}
								/>
							)
						}
					/>

					<div className='text-center'>
						<small>
							{token} • {localStorage.getItem('lastPath') ? localStorage.getItem('lastPath') : 'null'}
						</small>
					</div>
				</StackVertical>
			)}

			{error && (
				<ContentBlock
					error
					iconContent={{ icon: faLock, iconSize: '2x' }}
					title='Authorisation Error'
					content='Something went wrong while checking your credentials, please try logging in again'
					addon={<Button title='Login' colour={ColourStateOutline.Alert} onClick={() => logIn()} />}
				/>
			)}
		</div>
	);
}

export default OAuthRedirect;
